import styled from 'styled-components';

import { useHistory } from 'react-router-dom';
import { useLanguage } from '../../../Context/LanguageContext';

import FetchModule from '../Network/FetchModule';
import AdminLoginChangeModal from './AdminLoginChangeModal';
import { shouldHideBottomInfo } from './usePageCheck';

function BottomInfo(props) {
  const { isViewAdminChangeLogin, setIsViewAdminChangeLogin } = props;
  const history = useHistory();
  const { t } = useLanguage();
  const nowPage = window.location.pathname;

  if (shouldHideBottomInfo(nowPage)) return null;

  function onClickTitle() {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getData('store/', 'GET');

        if (responseData.status === 200 || responseData.status === 201 || responseData.status === 202 || responseData.status === 203) {
          const storeData = responseData.data[0];
          if (storeData?.isAdmin) {
            setIsViewAdminChangeLogin(true);
          }
        }
      }
    )();
  }

  function onCloseAdminModal() {
    setIsViewAdminChangeLogin(false);
  }

  // 로그인 정보 변경 버튼 클릭시 //
  // function onClickChangeAuthorizationButton() {
  //   const fetchModule = new FetchModule();
  //   (
  //     async () => {
  //       var responseData = await fetchModule.postDataOnlyLoginChange('account/asp/login/change', 'POST');
  //       if (responseData.data[0].status === 200) {
  //        window.localStorage.setItem('Token', 'Bearer ' + responseData.data[0].token);
  //        window.localStorage.setItem('RefreshToken', 'Bearer ' + responseData.data[0].refreshToken);
  //        window.localStorage.setItem('StoreId', responseData.data[0].storeId);
  //         window.location.reload();
  //       }
  //       // else if (responseData.status === 401) history.push('/');
  //     }
  //   )();
  // }

  return (
    <BottomInfoWrapper>
      <TopLevelWrapper>
        <InfoWrapper>
          <ButtonWrapper>
            <Button onClick={() => history.push('/rule/service')}>{t('bottomInfo.terms')}</Button>
            <Button onClick={() => history.push('/rule/location')}>{t('bottomInfo.location')}</Button>
            <Button onClick={() => history.push('/rule/privacy')}>{t('bottomInfo.privacy')}</Button>
            <Button onClick={() => history.push('/rule/promotion')}>{t('bottomInfo.promotion')}</Button>
            <Button onClick={() => history.push('/rule/refund')}>{t('bottomInfo.refund')}</Button>
          </ButtonWrapper>
          <TextWrapper>
            <Text>{t('bottomInfo.companyName')}</Text>
            <Text>{t('bottomInfo.ceo')}</Text>
            <Text>{t('bottomInfo.businessNumber')}</Text>
            <Text>{t('bottomInfo.privacyOfficer')}</Text>
            <Text>{t('bottomInfo.commerceNumber')}</Text>
          </TextWrapper>
          <TextWrapper>
            <Text>{t('bottomInfo.email')}</Text>
            <Text>{t('bottomInfo.tel')}</Text>
            <Text>{t('bottomInfo.address')}</Text>
          </TextWrapper>
          <ExplanationWrapper>
            <Explanation onClick={onClickTitle}>{t('bottomInfo.copyright')}</Explanation>
          </ExplanationWrapper>
        </InfoWrapper>
      </TopLevelWrapper>
      { isViewAdminChangeLogin && <AdminLoginChangeModal close={onCloseAdminModal}/> }
    </BottomInfoWrapper>
  )
}

export default BottomInfo;

const BottomInfoWrapper = styled.div`
  position: relative;
`;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100vw;
  min-width: 1194px;
  height: 296px;

  background-color: ${props => props.theme.background};
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  gap: 44px;

  margin-bottom: 40px;
`;

const Button = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 16px;

  color: ${props => props.theme.primary};

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    color: ${props => props.theme.primaryHover};
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  gap: 24px;

  margin-bottom: 16px;
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 16px;

  color: ${props => props.theme.bottomText};

  margin: 0 0 0 0;

  &:hover {
    cursor: default;
  }
`;

const ExplanationWrapper = styled.div`
  display: flex;

  margin-top: 20px;
`;

const Explanation = styled.p`
  font-family: Poppins-Regular;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;